import React, { useState } from "react";
import TextEditor from "./TextEditor";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../actions/userActions";
import { FaSync } from "react-icons/fa";
import axios from "axios";
import { notify } from "./notify";
import { Button } from "react-bootstrap";
import Message from "./Message";
import Skeleton from "react-loading-skeleton";
import { CLINIC_DETAILS_RESET } from "../constants/clinicConstants";

const ClinicDefaultPhysicianNote = ({
  defaultPhysicianNote,
  setDefaultPhysicianNote,
  clinicId,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const dispatch = useDispatch();
  const updateNote = async () => {
    // update Scans
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/clinics/${clinicId}/updateDefaultVisitPhysicianNote`,
        {
          defaultPhysicianNote,
        },
        config,
      );
      setDefaultPhysicianNote(data.updatedDefaultPhysicianNote);
      dispatch({ type: CLINIC_DETAILS_RESET });

      setLoading(false);
      notify({
        title: "Default Visit Note Update Status",
        message: <p className="lead">Data updated successfully.</p>,
        type: "success",
        duration: 4000,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
    }
  };
  return (
    <div>
      {loading ? (
        <Skeleton height="150px" />
      ) : error ? (
        <Message children={error} variant={`danger`} />
      ) : (
        <>
          <h3>Default Physician Note</h3>
          <TextEditor
            text={defaultPhysicianNote}
            setText={setDefaultPhysicianNote}
          />
          {!loading && (
            <div className="d-flex justify-content-end mt-3 width-100">
              <div>
                <Button variant="outline-info" onClick={() => updateNote()}>
                  <FaSync /> Update
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ClinicDefaultPhysicianNote;
